<template>
	<div class="side-area" :class="activeClass" :style="aboutSideStyle">
		<div class="side-con" :style="{width: aboutSideStyle.width}" :class="activeClass">
			<!--{{ getActivePath }} : {{ getActiveMain }}-->
			<!--关于我们-1-->
			<el-menu :default-active="String(getActiveMain ? getActiveMain[0] : 1)"
					 ref="aboutMenu"
					 class="el-side-menu"
					 mode="vertical"
					 @select="changeSelect"
					 v-if="getActivePath[0]==1||$name=='about'">
				<template>
					<!--<el-menu-item index="0">
						<div>
							{{ getActivePath }} : {{ getActiveMain }}
						</div>
					</el-menu-item>-->
					<el-menu-item index="1">
						<div>
							{{ whichLang($path) ? 'About Xhorse' : 'About Xhorse' }}
						</div>
					</el-menu-item>
					<el-menu-item index="2">
						<div>
							{{ whichLang($path) ? 'Patents and Certificates' : 'Patents and Certificates' }}
						</div>
					</el-menu-item>
					<el-menu-item index="3">
						<div>
							{{ whichLang($path) ? 'Business Structure' : 'Business Structure' }}
						</div>
					</el-menu-item>
					<el-menu-item index="4">
						<div>
							{{ whichLang($path) ? 'Extreme Horse Power' : 'Extreme Horse Power' }}
						</div>
					</el-menu-item>
					<el-menu-item index="5">
						<div>
							{{ whichLang($path) ? 'Employee' : 'Employee' }}
						</div>
					</el-menu-item>
					<el-menu-item index="6">
						<div>
							{{ whichLang($path) ? 'Responsibility' : 'Responsibility' }}
						</div>
					</el-menu-item>
					<el-menu-item index="7">
						<div>
							{{ whichLang($path) ? 'Address' : 'Address' }}
						</div>
					</el-menu-item>
				</template>
			</el-menu>
			<!--解决方案-2-->
			<el-menu :default-active="String(getActiveMain ? getActiveMain[0] : 1)" class="el-side-menu"
					 mode="vertical"
					 :popper-append-to-body="true"
					 :router="false"
					 active-text-color="#FFFFFF"
					 @select="changeSelect"
					 v-if="getActivePath[0]==2||$name=='solution'">
				<!--<template>{{ getActivePath }} : {{ getActiveMain }}</template>-->
				<template v-if="getActivePath">
					<!--二级菜单-1-->
					<template v-if="getActivePath[1]==1">
						<el-menu-item index="1">
							<div :style="{'line-height': '2.125rem'}">
								{{ whichLang($path) ? 'Key Cutting Machine Solutions' : 'Key Cutting Machine Solutions'
								}}
							</div>
						</el-menu-item>
					</template>

					<!--二级菜单-2-->
					<template v-if="getActivePath[1]==2">
						<!--<el-menu-item index="1">
							<div>
								{{ whichLang($path) ? 'VVDI Series' : 'VVDI Series' }}
							</div>
						</el-menu-item>-->
						<el-menu-item index="1">
							<div :style="{'line-height': '2.125rem'}">
								{{ whichLang($path) ? 'Professional Automotive Tools' : 'Professional Automotive Tools'
								}}
							</div>
						</el-menu-item>
					</template>

					<!--二级菜单-3-->
					<template v-if="getActivePath[1]==3">
						<el-menu-item index="1">
							<div :style="{'line-height': '4.25rem'}">
								{{ whichLang($path) ? 'IC Programmers Solutions' : 'IC Programmers Solutions' }}
							</div>
						</el-menu-item>
					</template>

					<!--二级菜单-4-->
					<template v-if="getActivePath[1]==4">
						<el-menu-item index="1">
							<div :style="{'line-height': '4.25rem'}">
								{{ whichLang($path) ? 'Access Solutions' : 'Access Solutions' }}
							</div>
						</el-menu-item>
					</template>

					<!--二级菜单-5-->
					<template v-if="getActivePath[1]==5">
						<el-menu-item index="1">
							<div :style="{'line-height': '4.25rem'}">
								{{ whichLang($path) ? 'HPC Solutions' : 'HPC Solutions' }}
							</div>
						</el-menu-item>
					</template>

					<!--二级菜单-6-->
					<template v-if="getActivePath[1]==6">
						<el-menu-item index="1">
							<div :style="{'line-height': '4.25rem'}">
								{{ whichLang($path) ? 'Customization ASIC Solutions' : 'Customization ASIC Solutions' }}
							</div>
						</el-menu-item>
					</template>

					<!--二级菜单-7-->
					<template v-if="getActivePath[1]==7">
						<el-menu-item index="1">
							<div :style="{'line-height': '2.125rem'}">
								{{ whichLang($path) ? 'Desktop 5-axis Engraving Machine' : 'Desktop 5-axis Engraving Machine'
								}}
							</div>
						</el-menu-item>
						<el-menu-item index="2">
							<div :style="{'line-height': '4.25rem'}">
								{{ whichLang($path) ? '5-axis Tool-sharpener' : '5-axis Tool-sharpener' }}
							</div>
						</el-menu-item>
						<el-menu-item index="3">
							<div :style="{'line-height': '2.125rem'}">
								{{ whichLang($path) ? '5-axis Dental Carving Machine' : '5-axis Dental Carving Machine'
								}}
							</div>
						</el-menu-item>
						<el-menu-item index="4">
							<div :style="{'line-height': '2.125rem'}">
								{{ whichLang($path) ? '6-axis Robotic Arm' : '6-axis Robotic Arm' }}
							</div>
						</el-menu-item>
						<el-menu-item index="5">
							<div :style="{'line-height': '2.125rem'}">
								{{ whichLang($path) ? 'Multi-axis Motion Test Platform' : 'Multi-axis Motion Test Platform'
								}}
							</div>
						</el-menu-item>
						<el-menu-item index="6">
							<div :style="{'line-height': '4.25rem'}">
								{{ whichLang($path) ? 'Servo System' : 'Servo System' }}
							</div>
						</el-menu-item>
					</template>

					<!--二级菜单-8-->
					<!--<template v-if="getActivePath[1]==8">
						<el-menu-item index="8">
							<div>
								{{ whichLang($path) ? 'Servo System Solutions' : 'Servo System Solutions' }}
							</div>
						</el-menu-item>
					</template>-->

					<!--二级菜单-9-->
					<template v-if="getActivePath[1]==9">
						<el-menu-item index="1">
							<div :style="{'line-height': '4.25rem'}">
								{{ whichLang($path) ? '3D Scanner' : '3D Scanner' }}
							</div>
						</el-menu-item>
						<el-menu-item index="2">
							<div :style="{'line-height': '2.125rem','text-overflow':'ellipsis'}">
								{{ whichLang($path) ? 'Plane Measuring Instrument machine' : 'Plane Measuring Instrument machine'
								}}
							</div>
						</el-menu-item>
						<el-menu-item index="3">
							<div :style="{'line-height': '2.125rem','text-overflow':'ellipsis'}">
								{{ whichLang($path) ?
                            'Tool measuring instrument  &  tool measuring	software' :
                            'Tool measuring instrument   &   tool measuring	software'
								}}
							</div>
						</el-menu-item>
						<el-menu-item index="4">
							<div :style="{'line-height': '4.25rem','text-overflow':'ellipsis'}">
								{{ whichLang($path) ? 'Optical key recognition tool' : 'Optical key recognition tool' }}
							</div>
						</el-menu-item>
						<el-menu-item index="5">
							<div :style="{'line-height': '4.25rem','text-overflow':'ellipsis'}">
								{{ whichLang($path) ? 'Three-dimensional Imaging' : 'Three-dimensional Imaging' }}
							</div>
						</el-menu-item>
						<el-menu-item index="6">
							<div :style="{'line-height': '4.25rem'}">
								{{ whichLang($path) ? 'Binocular Vision' : 'Binocular Vision' }}
							</div>
						</el-menu-item>
						<el-menu-item index="7">
							<div :style="{'line-height': '2.125rem','text-overflow':'ellipsis'}">
								{{
                                whichLang($path) ? 'Intelligent Object Detection & Classification' : 'Intelligent Object Detection & Classification'
								}}
							</div>
						</el-menu-item>
					</template>

					<!--二级菜单-10-->
					<template v-if="getActivePath[1]==10">
						<el-menu-item index="1">
							<div :style="{'line-height': '2.125rem'}">
								{{ whichLang($path) ? 'Intelligent  Workshop' : 'Intelligent  Workshop' }}
							</div>
						</el-menu-item>
						<el-menu-item index="2">
							<div :style="{'line-height': '2.125rem','text-overflow':'ellipsis'}">
								{{
                                whichLang($path) ? 'Intelligent  Automatic Complete Production Line' : 'Intelligent  Automatic Complete Production Line'
								}}
							</div>
						</el-menu-item>
						<el-menu-item index="3">
							<div :style="{'line-height': '2.125rem','text-overflow':'ellipsis'}">
								{{ whichLang($path) ?
                            'Ultra Short Pulse Laser Processing Technology and Integrated Equipment' : 'Ultra Short Pulse Laser Processing Technology and Integrated Equipment'
								}}
							</div>
						</el-menu-item>
						<el-menu-item index="4">
							<div :style="{'line-height': '2.125rem','text-overflow':'ellipsis'}">
								{{
                                whichLang($path) ? 'Automatic Test Equipment  Solution' : 'Automatic Test Equipment  Solution'
								}}
							</div>
						</el-menu-item>
					</template>

					<!--二级菜单-11-->
					<template v-if="getActivePath[1]==11">
						<el-menu-item index="1">
							<div :style="{'line-height': '2.125rem','text-overflow':'ellipsis'}">
								{{ whichLang($path) ? 'System Level Machining Accuracy Assurance Solution' : 'System Level Machining Accuracy Assurance Solution'
								}}
							</div>
						</el-menu-item>
					</template>

					<!--二级菜单-12-->
					<template v-if="getActivePath[1]==12">
						<el-menu-item index="1">
							<div :style="{'line-height': '2.125rem'}">
								{{
                                whichLang($path) ? 'MES（Manufacturing Execution System）' : 'MES（Manufacturing Execution System）'
								}}
							</div>
						</el-menu-item>
						<el-menu-item index="2">
							<div :style="{'line-height': '2.125rem'}">
								{{
                                whichLang($path) ? 'IEMS（Intelligent Equipment Management System）' : 'IEMS（Intelligent Equipment Management System）'
								}}
							</div>
						</el-menu-item>
						<el-menu-item index="3">
							<div :style="{'line-height': '2.125rem'}">
								{{ whichLang($path) ?
                            'FDP（Fast Dashboard Player）' : 'FDP（Fast Dashboard Player）'
								}}
							</div>
						</el-menu-item>
					</template>

					<!--二级菜单-13-->
					<template v-if="getActivePath[1]==13">
						<el-menu-item index="1">
							<div :style="{'line-height': '2.125rem'}">
								{{ whichLang($path) ? 'Web Services - Industrial Internet of Things  Solution' : 'Web Services - Industrial Internet of Things  Solution'
								}}
							</div>
						</el-menu-item>
					</template>
				</template>

				<!--默认菜单-->
				<template v-else>
					<el-menu-item index="1">
						<div>
							{{ whichLang($path) ? 'Key Cutting Machine Solutions' : 'Key Cutting Machine Solutions' }}
						</div>
					</el-menu-item>
				</template>
			</el-menu>
			<!--新闻-3-->
			<el-menu :default-active="String(getActiveMain ? getActiveMain[0] : 1)" class="el-side-menu"
					 mode="vertical"
					 @select="changeSelect"
					 v-if="getActivePath[0]==3||$name=='news'">
				<template>
					<el-menu-item index="1">
						<div>
							{{ whichLang($path) ? 'Going Global' : 'Going Global' }}
						</div>
					</el-menu-item>
					<!--<el-menu-item index="2">
						<div>
							{{ whichLang($path) ? 'Exhibition	Info' : 'Exhibition	Info' }}
						</div>
					</el-menu-item>
					<el-menu-item index="3">
						<div>
							{{ whichLang($path) ? 'Trends' : 'Trends' }}
						</div>
					</el-menu-item>-->
				</template>
			</el-menu>
			<!--技术支持-4-->
			<el-menu :default-active="String(getActiveMain ? getActiveMain[0] : 1)" class="el-side-menu"
					 mode="vertical"
					 @select="changeSelect"
					 v-if="getActivePath[0]==4||$name=='support'">
				<!--<el-menu-item index="1">
					<div>
						{{ getActivePath }}
					</div>
				</el-menu-item>-->

				<template v-if="getActivePath">
					<!--二级菜单-1-->
					<template v-if="getActivePath[1]==1">
						<el-menu-item index="1">
							<div>
								{{ whichLang($path) ? 'Key Cutting Machine Series' : 'Key Cutting Machine Series' }}
							</div>
						</el-menu-item>
						<el-menu-item index="2">
							<div>
								{{ whichLang($path) ? 'Remote and Transponder' : 'Remote and Transponder' }}
							</div>
						</el-menu-item>
					</template>


					<!--二级菜单-2-->
					<template v-if="getActivePath[1]==2">
						<el-menu-item index="1">
							<div>
								{{ whichLang($path) ? 'Key Cutting Machine Series' : 'Key Cutting Machine Series' }}
							</div>
						</el-menu-item>
						<el-menu-item index="2">
							<div>
								{{ whichLang($path) ? 'KEY TOOL&MINI KEY TOOl' : 'KEY TOOL&MINI KEY TOOl' }}
							</div>
						</el-menu-item>
						<el-menu-item index="3">
							<div>
								{{ whichLang($path) ? 'APP Functions' : 'APP Functions' }}
							</div>
						</el-menu-item>
						<el-menu-item index="4">
							<div>
								{{ whichLang($path) ? 'Remote and Transponder' : 'Remote and Transponder' }}
							</div>
						</el-menu-item>
						<el-menu-item index="5">
							<div>
								{{ whichLang($path) ? 'KEY TOOL MAX' : 'KEY TOOL MAX' }}
							</div>
						</el-menu-item>
						<el-menu-item index="6">
							<div>
								{{ whichLang($path) ? 'MINI OBD' : 'MINI OBD' }}
							</div>
						</el-menu-item>
					</template>
				</template>

				<!--默认菜单-->
				<template v-else>
					<el-menu-item index="1">
						<div>
							{{ whichLang($path) ? 'Key Cutting Machine Series' : 'Key Cutting Machine Series' }}
						</div>
					</el-menu-item>
					<el-menu-item index="2">
						<div>
							{{ whichLang($path) ? 'Remote and Transponder' : 'Remote and Transponder' }}
						</div>
					</el-menu-item>
				</template>
			</el-menu>
			<!--加入我们-5-->
			<el-menu :default-active="String(getActiveMain ? getActiveMain[0] : 1)" class="el-side-menu"
					 mode="vertical"
					 @select="changeSelect"
					 v-if="getActivePath[0]==5||$name=='join'">
				<template>
					<el-menu-item index="1">
						<div :style="{'line-height': IsPC()?'68px':'2.125rem'}">
							{{ whichLang($path) ? 'Why Choose Xhorse' : 'Why Choose Xhorse' }}
						</div>
					</el-menu-item>
					<el-menu-item index="2">
						<div :style="{'line-height': IsPC()?'68px':'2.125rem'}">
							{{ whichLang($path) ? 'Social Recruitment' : 'Social Recruitment' }}
						</div>
					</el-menu-item>
					<el-menu-item index="3">
						<div :style="{'line-height': IsPC()?'68px':'2.125rem'}">
							{{ whichLang($path) ? 'Campus Recruitment' : 'Campus Recruitment' }}
						</div>
					</el-menu-item>
				</template>
			</el-menu>
		</div>
	</div>
</template>

<script>

    export default {
        data: function () {
            return {};
        },
        props: {
            activeSideIndex: {
                type: Array,
            },
            activeTopIndex: {
                type: Array,
            },
            aboutSideStyle: {
                type: Object
            },
            activeClass: {
                type: String
            }
        },
        methods: {
            changeSelect: function (index, indexPath) {
                const _this = this;
				/*console.log("Tempalte[side]", indexPath)*/
                _this.$emit('go', {type: 'side', val: indexPath})
            },
            whichLang: function (path) {
                return path == 'zh-cn';
            },
            activeTo(params){
                const _this = this;
				/* console.log('side', params)*/
                const componentInfo = _this.$RegistedName;
                const dateTime = (new Date()).getTime()
                if (params.type == 'top') {
                    var fullPath = params.val.map((item) => {
                        if (toString(item).indexOf('-')) {
                            return parseInt(item.toString().split('-').reverse()[0]);
                        } else {
                            return parseInt(item);
                        }
                    });
                    _this.activeIndex.top = fullPath;
                    _this.activeIndex.side = fullPath.slice(-1);
                    _this.$router.push({name: componentInfo[fullPath[0]].componentName, params: {date: dateTime}})
                } else {
                    _this.activeIndex.side = params.val
                }
            },
            onFootActiveChange(val){
                const _this = this;
                //console.log("$footActiveSide", val)
            },
            IsPC() {
                var userAgentInfo = navigator.userAgent;
                var Agents = ["Android", "iPhone",
                    "SymbianOS", "Windows Phone",
                    "iPad", "iPod"];
                var flag = true;
                for (var v = 0; v < Agents.length; v++) {
                    if (userAgentInfo.indexOf(Agents[v]) > 0) {
                        flag = false;
                        break;
                    }
                }
                return flag;
            }
        },
        watch: {
            activeTopIndex: function (val) {
                const _this = this;
            },
            activeSideIndex: function (val) {
                const _this = this;
                //console.log("activeSideIndex", val)
            },
            '$footActiveSide': {
                handler: 'onFootActiveChange',
                deep: true
            },
        },
        computed: {
            getActivePath: function () {
                const _this = this;
                if (_this.activeTopIndex.length > 0) {
                    var fullPath = _this.activeTopIndex.map((item) => {
                        return parseInt(item)
                    });
                    return fullPath.length > 0 ? fullPath : false;
                }
                return [];
            },
            getActiveMain: function () {
                const _this = this;
                const activeTop = _this.activeTopIndex;
                const topLen = activeTop.length;
                if (topLen > 0) {
                    var activeMain = _this.activeSideIndex.map((item) => {
                        return parseInt(item);
                    });
                    if (activeMain.length) {
                        if (parseInt(topLen) === 2 && activeTop[0] != 1 && activeTop[0] != 5) {
                            return [1];
                        } else {
                            return activeMain;
                        }
                    }
                    return false;
                }
                return [];
            },
            getMiniWidth: function () {
                const viewWidth = window.screen.availWidth;
                return viewWidth > 1280;
            }
        },
        mounted(){
            const _this = this;
            const activePath = _this.$store.state;
            if (activePath.activeSide.length > 0 && activePath.activeTop.length > 0) {
                _this.$emit('go', {type: 'top', val: activePath.activeTop})
				/* console.log("$footActiveSide", _this.$footActiveSide)*/
            }
        },
        created(){
            const _this = this;
            _this.onFootActiveChange(0);
        }
    }

</script>

<style scoped>

	@import "../../assets/css/side.css";

</style>


// WEBPACK FOOTER //
// src/components/zh-cn/side.vue